import useBreakPoinst from "@hooks/useBreakPoinst";

const MessegingCard = ({
  icon,
  message,
  width,
  activeMasseges,
  sentMasseges,
  activatedSendingChannels,
}: any) => {
  const { isPhone } = useBreakPoinst();
  return (
    <div
      style={{
        width: width,
        height: "101px",
        borderRadius: "16px",
        padding: "24px",
        background: "#FFFFFF",
        border: "1px solid #EAEDF1",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "space-around",
        }}
      >
        <span
          style={{
            fontWeight: 400,
            fontSize: "14px",
            height: "19.2px",
            color: "#435363",
          }}
        >
          {message}
        </span>
        <span
          style={{
            fontWeight: 700,
            fontSize: isPhone ? "20px" : "32px",
            color: "#5B3FFF",
          }}
        >
          {activeMasseges} {sentMasseges} {activatedSendingChannels}
        </span>
      </div>

      {icon}
    </div>
  );
};

export default MessegingCard;
